import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const legacyJsdQueuesRoute: InvariantRoute = {
	name: 'legacy-jsd-queues',
	path: '/projects/:projectKey/queues/:custom(custom)?/:id?',
};
